export const Style = () => {
    return [
        {
            type: "childseat",
            style: [
                {
                    type: "base",
                    style: [
                        { type: "childseat_base_001" },
                        { type: "childseat_base_002" },
                    ],
                },
                {
                    type: "color",
                    style: [
                        { type: "childseat_color_001" },
                        { type: "childseat_color_002" },
                        { type: "childseat_color_003" },
                        { type: "childseat_color_004" },
                        { type: "childseat_color_005" },
                        { type: "childseat_color_006" },
                    ],
                },
                {
                    type: "handle",
                    style: [
                        { type: "childseat_addhandle_001" },
                        { type: "childseat_removehandle_001" },
                    ],
                },
                {
                    type: "headrest",
                    style: [
                        { type: "childseat_headrest_001" },
                        { type: "childseat_headrest_002" },
                        { type: "childseat_headrest_003" },
                        { type: "childseat_headrest_004" },
                        { type: "childseat_headrest_005" },
                    ],
                },
                {
                    type: "seat",
                    style: [
                        { type: "childseat_seat_001" },
                        { type: "childseat_seat_002" },
                        { type: "childseat_seat_003" },
                        { type: "childseat_seat_004" },
                        { type: "childseat_seat_005" },
                    ],
                },
            ],
        },
        {
            type: "pushchair",
            style: [
                {
                    type: "body",
                    style: [
                        { type: "pushchair_body_001" },
                        { type: "pushchair_body_002" },
                        { type: "pushchair_body_003" },
                        { type: "pushchair_body_004" },
                        { type: "pushchair_body_005" },
                        { type: "pushchair_body_006" },
                        { type: "pushchair_body_007" },
                        { type: "pushchair_body_008" },
                        { type: "pushchair_body_009" },
                    ],
                },
                {
                    type: "color",
                    style: [
                        { type: "pushchair_color_001" },
                        { type: "pushchair_color_002" },
                        { type: "pushchair_color_003" },
                        { type: "pushchair_color_004" },
                        { type: "pushchair_color_005" },
                        { type: "pushchair_color_006" },
                        { type: "pushchair_color_007" },
                        { type: "pushchair_color_008" },
                    ],
                },
                {
                    type: "frame",
                    style: [
                        { type: "pushchair_frame_001" },
                        { type: "pushchair_frame_002" },
                        { type: "pushchair_frame_003" },
                        { type: "pushchair_frame_004" },
                        { type: "pushchair_frame_005" },
                        { type: "pushchair_framebotbag_001" },
                        { type: "pushchair_framewheel_001" },
                        { type: "pushchair_handlesize_001" },
                        { type: "pushchair_handlesize_002" },
                        { type: "pushchair_leg_001" },
                        { type: "pushchair_leg_002" },
                    ],
                },
                {
                    type: "wheel",
                    style: [
                        { type: "pushchair_wheel_001" },
                        { type: "pushchair_wheel_002" },
                        { type: "pushchair_wheel_003" },
                        { type: "pushchair_wheel_004" },
                    ],
                },
            ],
        },
        {
            type: "stroller",
            style: [
                {
                    type: "color",
                    style: [
                        { type: "stroller_brigthness_001" },
                        { type: "stroller_color_001" },
                        { type: "stroller_color_002" },
                        { type: "stroller_color_003" },
                        { type: "stroller_color_004" },
                        { type: "stroller_color_005" },
                        { type: "stroller_color_006" },
                        { type: "stroller_color_007" },
                        { type: "stroller_color_008" },
                        { type: "stroller_color_009" },
                        { type: "stroller_color_010" },
                        { type: "stroller_color_011" },
                        { type: "stroller_color_012" },
                    ],
                },
                {
                    type: "frame",
                    style: [
                        { type: "stroller_size_001" },
                        { type: "stroller_handle_001" },
                        { type: "stroller_frame_001" },
                        { type: "stroller_frame_002" },
                        { type: "stroller_frame_003" },
                        { type: "stroller_frame_004" },
                        { type: "stroller_frame_005" },
                        { type: "stroller_frame_006" },
                    ],
                },
                {
                    type: "hood",
                    style: [
                        { type: "stroller_hood_001" },
                        { type: "stroller_hood_002" },
                        { type: "stroller_hood_003" },
                        { type: "stroller_hood_004" },
                        { type: "stroller_hood_005" },
                        { type: "stroller_hood_006" },
                        { type: "stroller_hood_007" },
                        { type: "stroller_hood_008" },
                        { type: "stroller_hood_009" },
                    ],
                },
                {
                    type: "wheel",
                    style: [
                        { type: "stroller_wheel_001" },
                        { type: "stroller_wheel_002" },
                        { type: "stroller_wheel_003" },
                        { type: "stroller_wheel_004" },
                        { type: "stroller_4wto3w" },
                    ],
                },
            ],
        },
    ];
};
